
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    CLOUDLOGINPAGE_SAVE_LOGIN_PAGE_REQUEST,
    CLOUDLOGINPAGE_GET_LOGIN_PAGE_REQUEST,
} from 'Redux/actionTypes';

import { 
    cloudLoginPageSaveLoginPageResult,
    cloudLoginPageGetTemplateResult,
} from 'Redux/actions';

import { endpoints } from 'Core/defaultValues';
import { clientMutation, clientQuery } from 'Core/data/GraphQLApi';
import { uploadFile } from 'Core/data/FileUpload';

function* updateLoginPage({ payload }) {
    const { fileKey, preview, content, language } = payload
    try {
        let QUERY = `
            mutation updateLoginPage($fileKey: String!,$preview: Boolean!,$language: String!,$dealerId: Int!){
                page: updateLoginPage(fileKey: $fileKey, preview: $preview, language: $language, dealerId: $dealerId) {
                    url
                    fileKey
                    preview
                }
            }
        `;

        let response = yield call(
            clientMutation,
            QUERY,
            {
                fileKey,
                preview, 
                language,
                dealerId: 16
            },
            endpoints.GRAPHQL_GENERAL,
        );
        const file = new Blob([content], { type: 'text/html' });
        yield uploadFile(response.page.url, file);
        yield put(cloudLoginPageSaveLoginPageResult({
            ...response.page,
            message: preview ? "login_page_preview_message" : "login_page_create_message"
        }))
    } catch (exc) {
        yield put(cloudLoginPageSaveLoginPageResult(null, exc))
        ExceptionManager(
            exc,
            "Modules/loginPage/main/redux/saga",
            "updateLoginPage",
        )
    }
}


function* getLoginPage({ payload }) {
    const { language } = payload

    try {
        let QUERY = `
            query getLoginPage ($fileKey: String, $preview: Boolean, $language: String!) {
                result: getLoginPage (fileKey: $fileKey, preview: $preview, language: $language)
            }
        `;

        let response = yield call(
            clientQuery,
            QUERY,
            {
                preview: false,
                language
            },
            endpoints.COGNITO_URL,
            {
            "x-api-key": endpoints.COGNITO_API_KEY
            }
        );
        
        yield put(cloudLoginPageGetTemplateResult(response?.result))

    } catch (exc) {
        yield put(cloudLoginPageGetTemplateResult())
        ExceptionManager(
            exc,
            "Modules/loginPage/main/redux/saga",
            "getLoginPage",
        )
    }
}

function* watchMethods() {
    yield takeEvery(CLOUDLOGINPAGE_SAVE_LOGIN_PAGE_REQUEST, updateLoginPage);
    yield takeEvery(CLOUDLOGINPAGE_GET_LOGIN_PAGE_REQUEST, getLoginPage);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}